isSideEffect